import React from "react";
import * as PropTypes from "prop-types";
import { formatThousand } from "utils/helpers";

const DisplayValue = ({ symbol = "AMB", value, noSpace = false }) => {
  return value ? (
    `${formatThousand(value)}${noSpace ? "" : " "}${symbol}`
  ) : (
    <span className="skeleton" />
  );
};

DisplayValue.propTypes = {
  value: PropTypes.any,
  size: PropTypes.string,
  color: PropTypes.any,
  symbol: PropTypes.string,
  styles: PropTypes.object,
};
export default DisplayValue;
